import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost';
  children: React.ReactNode;
  className?: string;
}
export function Button({
  variant = 'primary',
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'px-8 py-4 rounded-sm font-medium tracking-wide transition-all duration-300 flex items-center justify-center gap-2 text-sm uppercase tracking-widest';
  const variants = {
    primary: 'bg-gold text-black hover:bg-gold-light shadow-[0_0_20px_rgba(212,175,122,0.2)] hover:shadow-[0_0_30px_rgba(212,175,122,0.4)]',
    secondary: 'border border-gold/30 text-gold hover:bg-gold/10 hover:border-gold/60 backdrop-blur-sm',
    ghost: 'text-cream/70 hover:text-gold transition-colors'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-32">
      {children}
    </motion.button>;
}